<section class="material-table">
  <p-treeTable
    [rowTrackBy]="trackByFunction"
    [value]="secondaryMaterialData"
    (onNodeExpand)="onNodeExpand($event)"
    (onNodeCollapse)="onNodeCollapse($event)"
  >
    <ng-template pTemplate="header">
      <tr>
        <th class="material-table__toggle-cell">
          <i
            class="material-table__expand-collapse-icon"
            [ngClass]="tableExpanded ? 'icon-collapse-all' : 'icon-expand-all'"
            (click)="expandCollapseTable()"
          ></i>
        </th>
        <th class="material-table__tiny-cell"></th>
        <th class="material-table__text-cell">{{ 'MOUNTING.ARTICLE' | translate }}</th>
        <th [colSpan]="2" class="material-table__text-cell">{{ 'MOUNTING.NAME' | translate }}</th>
        <th class="material-table__text-cell">{{ 'MOUNTING.QUANTITY' | translate }}</th>
        <th class="material-table__number-cell">{{ 'MOUNTING.MOUNTED' | translate }}</th>
        <th class="material-table__number-cell">{{ 'MOUNTING.CONSUMED' | translate }}</th>
        <th class="material-table__number-cell">{{ 'MOUNTING.OPEN' | translate }}</th>
        <th class="material-table__number-cell">{{ 'MOUNTING.ON_HAND' | translate }}</th>
        <th *ngIf="buttonTemplate" [style]="buttonTemplateStyle"></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
      <tr
        [ngClass]="{
          'second-level-row': rowData.displayMode === MaterialTableDataRowDisplayMode.Container,
          'first-level-row': rowData.displayMode === MaterialTableDataRowDisplayMode.BillOfMaterial,
          'material-table__dummy-row': rowData.isVirtualContainer
        }"
      >
        <td class="material-table__toggle-cell">
          <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
        </td>
        <ng-container *ngIf="rowData.displayMode === MaterialTableDataRowDisplayMode.BillOfMaterial">
          <td class="material-table__tiny-cell">
            <div *ngIf="rowData.showLayerNumber">{{ rowData.layerNumber }}</div>
          </td>
          <td class="material-table__text-cell">
            <div class="material-table__article-icon-layout">
              <lib-article-classification
                [classification]="rowData.article.classification"
                [size]="ArticleClassificationSize.Small"
              ></lib-article-classification>
              <div class="material-table__article-layout">
                <div>{{ rowData.article.externalArticleId }}</div>
                <div>{{ rowData.article.externalConfigurationId }}</div>
              </div>
            </div>
          </td>
          <td [colSpan]="2" class="material-table__text-cell">{{ rowData.article.articleName }}</td>
          <td class="material-table__text-cell">
            <div *ngIf="rowData.containerCount">
              <i class="icon-container material-table__icon"></i>
              {{ rowData.containerCount | number }}
            </div>
          </td>
          <ng-container>
            <ng-container *ngIf="isFlushingPrincipleManual(rowData); then mountedQuantity; else emptyQuantity"></ng-container>
          </ng-container>
        </ng-container>

        <ng-container *ngIf="rowData.displayMode === MaterialTableDataRowDisplayMode.Container">
          <ng-container *ngIf="!isToolType(rowData)">
            <td class="material-table__tiny-cell">
              <div>
                <i *ngIf="isAlternativeMaterial(rowData, rowNode.parent.data)" class="icon-active-order"></i>
              </div>
              <div>&nbsp;</div>
            </td>
            <td class="material-table__text-cell material-table__less-important-text">
              <div>{{ 'MOUNTING.IDENTIFICATION' | translate }}</div>
              <div><span [innerHTML]="rowData.identificationCode | sscc"></span></div>
            </td>
            <td class="material-table__text-cell material-table__less-important-text">
              <div>{{ rowData.batchInternalTitle | translate }}</div>
              <div>{{ rowData.internalBatchId | emptyTextPlaceholder }}</div>
            </td>
            <td class="material-table__text-cell material-table__less-important-text">
              <div>{{ rowData.batchExternalTitle | translate }}</div>
              <div>{{ rowData.externalBatchId | emptyTextPlaceholder }}</div>
            </td>
            <ng-container *ngIf="isAlternativeAvailable(rowNode.parent.data); then alternative; else emptyAlternative"></ng-container>
            <td class="material-table__number-cell">
              {{ rowData.mountedQuantity | formatQuantity }}
            </td>
          </ng-container>
          <ng-container *ngIf="isToolType(rowData)">
            <td class="material-table__tiny-cell"></td>
            <td class="material-table__text-cell">{{ 'MOUNTING.SERIAL_NUMBER' | translate }}</td>
            <td [colSpan]="2" class="material-table__text-cell material-table__less-important-text">
              {{ rowData.identificationCode | emptyTextPlaceholder }}
            </td>
            <td class="material-table__text-cell"></td>
            <td class="material-table__number-cell">‒</td>
          </ng-container>
        </ng-container>

        <ng-container *ngIf="!isToolType(rowData)">
          <td class="material-table__number-cell">{{ rowData.consumedQuantity | formatQuantity }}</td>
          <td class="material-table__number-cell">{{ rowData.openQuantity | formatQuantity }}</td>
          <td class="material-table__number-cell">{{ rowData.onHandQuantity | formatQuantity }}</td>
        </ng-container>
        <ng-container *ngIf="isToolType(rowData)">
          <td class="material-table__number-cell">‒</td>
          <td class="material-table__number-cell">‒</td>
          <td class="material-table__number-cell">{{ rowData.onHandQuantity | formatQuantity }}</td>
        </ng-container>

        <td *ngIf="buttonTemplate" class="material-table__last-cell" [style]="buttonTemplateStyle">
          <ng-container *ngTemplateOutlet="buttonTemplate; context: { $implicit: rowData }"></ng-container>
        </td>

        <ng-template #emptyQuantity>
          <td class="material-table__number-cell">‒</td>
        </ng-template>
        <ng-template #mountedQuantity>
          <td class="material-table__number-cell">
            <div>{{ calculateMountedQuantity(rowData) | formatQuantity }}</div>
          </td>
        </ng-template>

        <ng-template #emptyAlternative>
          <td class="material-table__number-cell"></td>
        </ng-template>
        <ng-template #alternative>
          <td class="material-table__text-cell">
            <div>{{ rowData.article.articleName }}</div>
            <div>{{ rowData.article.externalArticleId }}</div>
            <div>{{ rowData.article.externalConfigurationId }}</div>
          </td>
        </ng-template>
      </tr>
    </ng-template>
  </p-treeTable>
  <lib-table-no-data-message [loading]="loading" [data]="secondaryMaterialData"></lib-table-no-data-message>
  <lib-table-loading-indicator [loading]="loading" [data]="secondaryMaterialData"></lib-table-loading-indicator>
</section>
